import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchPotentialLeaguesForCloningMergedParams,
  selectPotentialLeaguesForCloningPagination,
  setPagePotentialLeaguesForCloning,
} from '../../reducers/potential_leagues_for_cloning'
import { PaginationControls } from '../common'

const MAX_DISPLAYED_PAGES = 5

const LeaguesBrowserPagination = () => {
  const dispatch = useDispatch()
  const pagination = useSelector(selectPotentialLeaguesForCloningPagination)
  const { page: currentPage, totalPages } = pagination
  const handlePageChange = useCallback((page) => {
    if (page < 1 || page > totalPages) {
      return
    }
    dispatch(setPagePotentialLeaguesForCloning(page))
    dispatch(fetchPotentialLeaguesForCloningMergedParams())
  }, [ pagination ])


  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      handlePageChange={handlePageChange}
      maxDisplayedPages={MAX_DISPLAYED_PAGES}
    />
  )
}

export default LeaguesBrowserPagination
